export interface Invoice {
  readonly id: string;
  readonly number: string;
  readonly orderId: string;
  readonly customer: string;
  readonly amountCents: number;
  readonly status: InvoiceStatus;
  readonly issuedAt: string;
  readonly dueAt: string;
  readonly paidAt: string | null;
}

export const InvoiceStatus = {
  Draft: 'draft',
  Sent: 'sent',
  Paid: 'paid',
  Overdue: 'overdue',
} as const;
export type InvoiceStatus = (typeof InvoiceStatus)[keyof typeof InvoiceStatus];

export const ALL_INVOICE_STATUSES: readonly InvoiceStatus[] = [
  InvoiceStatus.Draft,
  InvoiceStatus.Sent,
  InvoiceStatus.Paid,
  InvoiceStatus.Overdue,
];

export const INVOICE_STATUS_LABELS: Readonly<Record<InvoiceStatus, string>> = {
  [InvoiceStatus.Draft]: 'Draft',
  [InvoiceStatus.Sent]: 'Sent',
  [InvoiceStatus.Paid]: 'Paid',
  [InvoiceStatus.Overdue]: 'Overdue',
};
